import React, { useState } from "react";
import { Table } from "antd";
import { Label } from "reactstrap";
import { useSelector } from "react-redux";
import moment from "moment-jalaali";
import RangePickerEvents from "../RangePicker";
import { gql, useMutation } from "@apollo/client";
import { error } from "../../../Controllers/toast";
import dayjs from "dayjs";

const GET_OPTIMIZER_EVENTS = gql`
  mutation GetOptimizerEvents(
    $PO_id: Int!
    $dates: [Date]
    $offset_date: Int
    $skip: Int
  ) {
    GetOptimizerEvents(
      PO_id: $PO_id
      dates: $dates
      offset_date: $offset_date
      skip: $skip
    ) {
      events {
        PO_id
        event_code
        event_time
        description
        Event_Description {
          event_code
          title
          content
        }
      }
      count
    }
  }
`;

const EventsTab = ({ events, dateHOC, powerOptimizer, count }) => {
  const [eventsData, setEventsData] = useState(events);
  const [currentDate, setCurrentDate] = useState(dateHOC);
  const [total, setCount] = useState(count);
  const lang_choiced = useSelector((state) => state.lang_change);


  // console.log(dateHOC, "is dateHOC EventsTab")

  const [getOptimizerEvents] = useMutation(GET_OPTIMIZER_EVENTS, {
    onCompleted: (res) => {
      // console.log(res.GetOptimizerEvents, "is optimizer events");
      setEventsData(res.GetOptimizerEvents.events);
      setCount(res.GetOptimizerEvents.count);
    },
    onError: (err) => {
      // console.log(err);
      error("مشکلی رخ داده است!");
    },
  });

  const columns = [
    {
      title: lang_choiced.pages.byPanel.PanelGroup.Line.Modal.eventTab.table.event_time,
      dataIndex: "event_time",
      width: 150,
      render: (text) => {
        // console.log(text, "date text")
        return (
          <span className="ltr">
            {moment(new Date(text)).format("jYYYY-jMM-jDD HH:mm:ss")}
          </span>
        );
      },
      className: "ltr",
    },
    {
      title: lang_choiced.pages.byPanel.PanelGroup.Line.Modal.eventTab.table.event_title,
      dataIndex: "Event_Description",
      render: (text) => text.title,
      width: 250,
    },
    {
      title: lang_choiced.pages.byPanel.PanelGroup.Line.Modal.eventTab.table.event_description,
      // dataIndex: "",
      render: (text) => (
        <span>
          {text.Event_Description.content}
          {text.description ? ` (${text.description})` : ""}
        </span>
      ),
      width: 350,
    },
    {
      title: lang_choiced.pages.byPanel.PanelGroup.Line.Modal.eventTab.table.event_code,
      dataIndex: "event_code",

      width: 120,
      defaultSortOrder: "descend",
      sorter: (a, b) => parseInt(a.repair_code) - parseInt(b.repair_code),
    },
  ];
  return (
    <div>
      <div key={3}>
        <strong style={{ color: "red" }}>
          {lang_choiced.pages.byPanel.PanelGroup.Line.Modal.eventTab.tip}
        </strong>
        <Label color="danger">
          {lang_choiced.pages.byPanel.PanelGroup.Line.Modal.eventTab.tipText}
        </Label>
      </div>
      <div className="text-center mb-2">
        <RangePickerEvents
          setDatesHOC={(date) => {
            setCurrentDate([
              moment(date[0], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
              moment(date[1], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
            ]);
            // console.log("change Date for RangePicker", [
            //   moment(date[0], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
            //   moment(date[1], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
            // ]);
            getOptimizerEvents({
              variables: {
                PO_id: powerOptimizer.PO_id,
                dates: [
                  moment(date[0], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
                  moment(date[1], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
                ],
                offset_date: new Date().getTimezoneOffset(),
              },
            });
          }}
          dateHOC={currentDate}
        />
      </div>
      <Table
        striped
        bordered
        small
        hover
        size="small"
        columns={columns}
        dataSource={eventsData}
        pagination={{
          pageSize: 5,
          // onChange: (page, pageSize) => {
          //   getOptimizerEvents({
          //     variables: {
          //       PO_id: powerOptimizer.PO_id,
          //       dates: currentDate,
          //       offset_date: new Date().getTimezoneOffset(),
          //       skip: (page-1) * pageSize,
          //     },
          //   });
          // },
          total: total,
        }}
        rowKey={(record) => record.event_time}
        style={{ overflowX: "auto" }}
      />
    </div>
  );
};

export default EventsTab;
